import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  TextField,
  Grid,
  Card,
  CardContent,
  MenuItem,
  Select,
  IconButton,
  Button,
  CircularProgress,
} from "@mui/material";
import Download from "../../common/assets/images/Download.svg";
import { Buffer } from "buffer";
import NotificationView from "../../Dashboard/components/NotificationView";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import html2canvas from "html2canvas";
const pdfConverter = require("jspdf");
import { jsPDF } from "jspdf";
import "../../poppins/Poppins-Regular-normal";
import "../../poppins/Poppins-Bold-bold";

import { Line } from "react-chartjs-2";
import Chart from "react-apexcharts";

import { GetPreTermCheckData } from "../reducers/ReportsDataThunk";
import { Chart as ChartJS, registerables } from "chart.js";

import "../../dataEntry/styles/DataEntry.scss";
import NotificationPdf from "./NotificationPdf";
import ChartLegends from "./ChartLegends";

export const data = {
  datasets: [
    {
      data: [12, 19],
      backgroundColor: ["#EB81C1", "#5D66ED"],
      borderColor: ["rgba(255, 99, 132, 1)", "rgba(54, 162, 235, 1)"],
      borderWidth: 1,
    },
  ],
};

const labels1 = ["R1", "R2", "R3"];

const data1 = {
  labels: labels1,
  datasets: [
    {
      borderColor: "#F28ECB",
      data: [20, 90, 88],
    },
    {
      borderColor: "#5D66ED",
      data: [24, 45, 20],
    },
  ],
};

const PreTermCheck = () => {
  ChartJS.register(...registerables);
  const patient = useSelector((state) => state.patient);
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const hospital_name = user.userProfile.hospital_name;
  const hospital_id = user.userProfile.hospital_id;
  const branch = useSelector((state) => state.Reports?.SelectedBranchdata);
  const [doughnutData, setDoughnutData] = React.useState();
  const [lineChartData, setLineChartData] = React.useState();
  const [chartData, setChartData] = React.useState();
  const [rangeType, setRangeType] = React.useState("Select Dates");
  const [sepsisStatus, setSepsisStatus] = React.useState("positive");
  const [fromDate, setFromDate] = React.useState(
    moment().subtract(1, "month").format()
  );
  const [toDate, setToDate] = React.useState(moment().format());
  const [fromYear, setFromYear] = React.useState(
    moment().subtract(1, "year").format()
  );
  const [toYear, setToYear] = React.useState(moment().format());
  const [month, setMonth] = React.useState(moment().format());
  const [notificationData, setNotificationData] = React.useState(null);
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [enableDownload, setEnableDownload] = React.useState(false);

  React.useEffect(() => {
    if (chartData && chartData.length) {
      const labels = [],
        preTermYes = [],
        preTermNo = [];

      chartData.map((record) => {
        labels.push(record.label);
        preTermYes.push(record.preTermYes);
        preTermNo.push(record.preTermNo);
      });

      const LineChartResponse = {
        labels,
        datasets: [
          {
            label: "PreTerm Yes",
            borderColor: "#765FA7",
            data: preTermYes,
          },
          { label: "PreTerm No", borderColor: "#D27F70", data: preTermNo },
        ],
      };
      setLineChartData(LineChartResponse);
    }
  }, [chartData]);

  useEffect(() => {
    getReports();
  }, [
    rangeType,
    fromDate,
    toDate,
    month,
    fromYear,
    toYear,
    branch?.hospital_branch_id,
    sepsisStatus,
  ]);

  const getReports = () => {
    setIsLoading(true);
    let params;

    switch (rangeType) {
      case "Select Dates":
        params = {
          sepsisStatus: sepsisStatus,
          range: "custom",
          start: moment(fromDate).format("MM-DD-YYYY"),
          end: moment(toDate).format("MM-DD-YYYY"),
        };
        break;
      case "Monthly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "monthly",
          start: moment(month).format("MM-DD-YYYY"),
        };
        break;
      case "Quarterly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "quarterly",
        };
        break;
      case "Yearly":
        params = {
          sepsisStatus: sepsisStatus,
          range: "yearly",
          start: moment(fromYear).format("MM-DD-YYYY"),
          end: moment(toYear).format("MM-DD-YYYY"),
        };
        break;
    }

    const req = { hospital_id, branch_id: branch.hospital_branch_id, params };
    dispatch(GetPreTermCheckData(req))
      .unwrap()
      .then((resdata) => {
        const doughnutChartData = {
          options: {
            labels: ["PreTerm Yes", "PreTerm No"],
            dataLabels: {
              enabled: true,
              style: {
                fontFamily: "Poppins",
              },
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    total: {
                      showAlways: true,
                      show: true,
                      fontFamily: "Poppins",
                      color: "#aeaeae",
                    },
                    value: {
                      fontFamily: "Poppins",
                      fontSize: "24px",
                    },
                  },
                },
              },
            },
            fill: { colors: ["#765FA7", "#D27F70"] },
            colors: ["#765FA7", "#D27F70"],
            legend: {
              show: false,
            },
          },
          series: [
            resdata.response.preTermYesCount,
            resdata.response.preTermNoCount,
          ],
        };
        /*  const doughnutResponse = {
          // labels: ["PreTerm Yes", "PreTerm No"],
          datasets: [
            {
              data: [
                resdata.response.preTermYesCount,
                resdata.response.preTermNoCount,
              ],
              backgroundColor: ["#765FA7", "#D27F70"],
              borderWidth: 1,
            },
          ],
        }; */

        setEnableDownload(
          resdata.response.preTermYesCount > 0 ||
            resdata.response.preTermNoCount > 0
            ? true
            : false
        );
        setIsLoading(false);
        setDoughnutData(doughnutChartData);
        setChartData(resdata.response.graphData);
      });
  };
  const div2PDF = async (e) => {
    e.preventDefault();

    let doughnutChart =
      window.document.getElementsByClassName("doughnutChart")[0];
    const doughnutChartCanvas = await html2canvas(doughnutChart);
    const doughnutChartImage = doughnutChartCanvas.toDataURL("image/png");

    let lineChart =
      window.document.getElementsByClassName("genderLineChart")[0];
    const lineChartCanvas = await html2canvas(lineChart);
    const lineChartImage = lineChartCanvas.toDataURL("image/png");

    const pdf = new jsPDF("l", "pt", "a4");
    pdf.setFont("Poppins", "normal");
    pdf.setFillColor(244, 131, 81);
    pdf.rect(50, 90, 740, 40, "F");

    pdf.setFont("Poppins-Bold", "bold");
    pdf.setFontSize(20);
    const heading = "PreTerm Check Report";
    pdf.setTextColor(255, 255, 255);
    pdf.text(heading, 320, 115);

    var avyantraImage = new Image();
    avyantraImage.src = "./assets/avyantra.jpg";
    pdf.addImage(avyantraImage, "jpg", 10, 10, 60, 13);

    pdf.setFontSize(10);
    pdf.setTextColor(135, 135, 135);
    pdf.text(`Generated On: ${moment().format("DD-MM-YYYY")}`, 700, 20);

    var prescoImage = new Image();
    prescoImage.src = "./assets/presco.png";
    pdf.addImage(prescoImage, "png", 380, 30, 53.5, 14.12);
    pdf.text("Neonatal Sepsis Prediction Platform", 330, 60);

    pdf.setFontSize(15);
    pdf.setTextColor(135, 135, 135);

    let rangeValue;
    switch (rangeType) {
      case "Select Dates":
        rangeValue =
          moment(fromDate).format("DD-MM-YY") +
          " To " +
          moment(toDate).format("DD-MM-YY");
        break;
      case "Yearly":
        rangeValue =
          moment(fromYear).format("YYYY") +
          " To " +
          moment(toYear).format("YYYY");
        break;
      case "Monthly":
        rangeValue =
          moment(month).startOf("month").format("DD-MM-YY") +
          " To " +
          moment(month).endOf("month").format("DD-MM-YY");
        break;
      case "Quarterly":
        rangeValue =
          moment().startOf("quarter").format("DD-MM-YY") +
          " To " +
          moment().endOf("quarter").format("DD-MM-YY");
        break;
    }

    // Calculate the width of each label text
    const labelWidths = {
      "Hospital: ":
        (pdf.getStringUnitWidth("Hospital: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
      "Branch: ":
        (pdf.getStringUnitWidth("Branch: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
      "Range: ":
        (pdf.getStringUnitWidth("Range: ") * pdf.internal.getFontSize()) /
        pdf.internal.scaleFactor,
    };

    const totalWidth =
      labelWidths["Hospital: "] +
      labelWidths["Branch: "] +
      labelWidths["Range: "];
    const availableSpace = pdf.internal.pageSize.getWidth() - 110 - totalWidth; // Total width - x-coordinate of first label

    const spaceBetweenLabels = availableSpace / 2;

    const labelX = {
      "Hospital: ": 55,
      "Branch: ": 10 + labelWidths["Hospital: "] + spaceBetweenLabels,
      "Range: ":
        pdf.internal.pageSize.getWidth() -
        labelWidths["Range: "] -
        `${rangeType !== "Yearly" ? 230 : 135}`,
    };

    pdf.setFont("Poppins", "normal");
    pdf.text(`Hospital :`, labelX["Hospital: "], 160);
    pdf.text(`Branch :`, labelX["Branch: "], 160);
    pdf.text(`Range :`, labelX["Range: "], 160);

    pdf.setFont("Poppins-Bold", "bold");
    pdf.text(`${hospital_name}`, labelX["Hospital: "] + 75, 160);
    pdf.text(`${branch.branch_name}`, labelX["Branch: "] + 70, 160);
    pdf.text(`${rangeValue}`, labelX["Range: "] + 70, 160);

    pdf.addImage(doughnutChartImage, "png", 50, 190, 290, 250);
    pdf.addImage(lineChartImage, "png", 350, 190, 390, 250);
    const blobData = pdf.output("arraybuffer");
    const buffer = Buffer.from(blobData);
    setNotificationData(buffer);
    setDialogOpen(true);
  };

  const lineOptions = {
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: `${rangeType !== "Select Dates" ? "Year" : "Date"}`,
        },
        grid: {
          display: false,
        },
      },
      y: {
        title: {
          display: true,
          text: "Count",
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <React.Fragment>
      <NotificationPdf
        data={notificationData}
        open={dialogOpen}
        action={setDialogOpen}
        title="Pre-Term Check"
      />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div>
          <Card variant="none">
            <CardContent style={{padding:"0px 5px"}}>
              <div>
                <div className="reports_chart_title">
                  {/* <Grid container>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      style={{
                        margin: "0px auto",
                        textAlign: "center",
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Pre-Term Check
                    </Grid>
                  </Grid>
                  <hr /> */}
                  <Grid
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                  >
                    <Grid
                      item
                      xs={12}
                      sm={3}
                      style={{
                        marginTop: 30,
                        fontSize: "20px",
                        fontWeight: "600",
                      }}
                    >
                      Pre-Term Check
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <Grid container>
                        <Grid item xs={12} sm={2}>
                          <label
                            htmlFor="Sepsis Status"
                            className="dataentry_label1"
                            style={{ display: "block" }}
                          >
                            Sepsis Status
                          </label>
                          <Select
                            labelId="sepsis_status"
                            id="sepsis_status"
                            name="sepsis_status"
                            label=""
                            size="small"
                            className="dataentry_input"
                            value={sepsisStatus}
                            onChange={(e) => {
                              setSepsisStatus(e.target.value);
                            }}
                            style={{ fontSize: "14px", padding: "3px 0px" }}
                          >
                            <MenuItem value="positive">Positive</MenuItem>
                            <MenuItem value="negative">Negative</MenuItem>
                          </Select>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <label
                            htmlFor="Range"
                            className="dataentry_label1"
                            style={{ display: "block" }}
                          >
                            Range
                          </label>
                          <Select
                            labelId="range"
                            id="range"
                            name="range"
                            label=""
                            size="small"
                            className="dataentry_input"
                            value={rangeType}
                            onChange={(e) => {
                              setRangeType(e.target.value);
                            }}
                            style={{
                              fontSize: "14px",
                              padding: "3px 0px",
                              marginTop: 3,
                            }}
                          >
                            <MenuItem value="Select Dates">
                              Select Dates
                            </MenuItem>
                            <MenuItem value="Yearly">Yearly</MenuItem>
                            <MenuItem value="Monthly">Monthly</MenuItem>
                            <MenuItem value="Quarterly">Quarterly</MenuItem>
                          </Select>
                        </Grid>

                        {rangeType === "Quarterly" && (
                          <Grid item xs={12} sm={6}></Grid>
                        )}

                        {rangeType === "Yearly" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                From
                              </label>
                              <DatePicker
                                size="small"
                                id="from_year"
                                name="from_year"
                                views={["year"]}
                                minDate="01-01-2019"
                                maxDate={toYear}
                                value={fromYear}
                                className="dataentry_input"
                                onChange={(date) => {
                                  setFromYear(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="To"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                To
                              </label>
                              <DatePicker
                                size="small"
                                views={["year"]}
                                id="to_year"
                                name="to_year"
                                value={toYear}
                                minDate={fromYear}
                                maxDate={moment().format()}
                                className="dataentry_input"
                                onChange={(date) => {
                                  setToYear(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    className="dataentry_input"
                                    size="small"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                          </>
                        ) : null}

                        {rangeType === "Select Dates" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                From
                              </label>
                              <DatePicker
                                id="from_month"
                                size="small"
                                name="from_month"
                                inputFormat="DD-MM-YYYY"
                                className="dataentry_input"
                                minDate="01-01-2019"
                                maxDate={toDate}
                                value={fromDate}
                                onChange={(date) => {
                                  setFromDate(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="To"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                To
                              </label>
                              <DatePicker
                                id="to_month"
                                name="to_month"
                                size="small"
                                inputFormat="DD-MM-YYYY"
                                className="dataentry_input"
                                minDate={fromDate}
                                maxDate={moment().format()}
                                value={toDate}
                                onChange={(date) => {
                                  setToDate(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                          </>
                        ) : null}

                        {rangeType === "Monthly" ? (
                          <>
                            <Grid item xs={12} sm={3}>
                              <label
                                htmlFor="From"
                                className="dataentry_label1"
                                style={{ display: "block" }}
                              >
                                Month
                              </label>
                              <DatePicker
                                id="from_month"
                                name="from_month"
                                size="small"
                                inputFormat="DD-MM-YYYY"
                                className="dataentry_input"
                                value={month}
                                minDate="01-01-2019"
                                maxDate={moment().format()}
                                views={["year", "month"]}
                                onChange={(date) => {
                                  setMonth(date["$d"]);
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    className="dataentry_input"
                                    helperText={null}
                                    onKeyDown={(e) => {
                                      e.preventDefault();
                                   }}
                                   autocomplete="off"
                                  />
                                )}
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}></Grid>
                          </>
                        ) : null}
                        <Grid item xs={12} sm={2}>
                          <Button
                            variant="contained"
                            size="small"
                            className="report-download-button"
                            disabled={isLoading || !enableDownload}
                            onClick={(e) => div2PDF(e)}
                          >
                            Download Report
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
                <hr className="tag-line-border" />
                {isLoading ? (
                  <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    style={{
                      height: "480px",
                    }}
                  >
                    <Grid sm={1}>
                      <CircularProgress color="success" />
                    </Grid>
                  </Grid>
                ) : (
                  <Grid container spacing={2}>
                    {(doughnutData && doughnutData.series[0] !== 0) ||
                    (doughnutData && doughnutData.series[1] !== 0) ? (
                      <>
                        <Grid item xs={12} sm={5} className="doughnutChart">
                          <div className="chart_data">
                            <p className="chart_title">
                              Percentage of Pre-Term Babies
                            </p>
                            <div className="chart-body">
                              {doughnutData ? (
                                <Chart
                                  series={doughnutData.series}
                                  options={doughnutData.options}
                                  type="donut"
                                  width="380"
                                />
                              ) : null}
                            </div>
                          </div>
                          <ChartLegends
                            labelOne={"Pre-term Yes"}
                            labelTwo={"Pre-term No"}
                            colorOne={"#5F4A8B"}
                            colorTwo={"#E69A8D"}
                          />
                        </Grid>

                        <Grid item xs={12} sm={7} className="genderLineChart">
                          <div className="chart_data">
                            <p className="chart_title">Pre-Term Babies</p>

                            {lineChartData ? (
                              <Line
                                data={lineChartData}
                                options={lineOptions}
                                className="donut_class"
                              />
                            ) : null}
                          </div>
                        </Grid>
                      </>
                    ) : (
                      <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        style={{
                          height: "480px",
                        }}
                      >
                        <Grid sm={4}>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              width: "100%",
                              alignItems: "center",
                              margin: "1rem 0",
                            }}
                          >
                            No data Found
                          </div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                )}
              </div>
            </CardContent>
          </Card>
        </div>
      </LocalizationProvider>
    </React.Fragment>
  );
};

export default PreTermCheck;
